<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Banka Kaydı Yok"
      type="success"
      :closable="false"
      v-if="!data && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="data"
      row-key="id"
      show-summary
      :summary-method="TableFooter"
      :height="Height">
      <el-table-column
        label="Banka"
        width="65"
      >
        <template slot-scope="scope"><img :src="'https://pos.mudu.pro/oi/banka/'+scope.row.Banka+'.png'" width="50">
        </template>
      </el-table-column>
      <el-table-column
        prop="Tanim"
        label="Tanım">
      </el-table-column>
      <el-table-column
        prop="Bakiye"
        label="Bakiye"
        align="right"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      Liste: null,
      data: false,
      lo: false,
      AltToplam: 0,
      Height: window.innerHeight - 370
    }
  },
  methods: {
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'panel/banka'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.AltToplam = response.AltToplam;
            this.lo = false;
            if (this.Liste) this.data = true;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    TableFooter() {
      const sums = [];

      sums[2] = this.AltToplam;


      return sums;
    },
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelBanka.vue